export default __webpack_public_path__ + "static/media/url.db010487.png";